import * as React from "react";
import { ArrowLeftIcon } from "../../../components/icons";
import { Button } from "../../../components/ui/button";

export interface ViewHeaderProps {
  title: React.ReactNode;
  onBack: () => void;
  /** Sits at the right: a refresh button, a count, a menu. */
  action?: React.ReactNode;
}

/**
 * The top line of a sub-view inside Assembly: a back arrow and the view's name.
 * The three sub-views used to open with a bare "Back" text button and no title, so
 * nothing on screen said where you were.
 */
const ViewHeader = ({ title, onBack, action }: ViewHeaderProps) => (
  <div className="flex min-w-0 flex-row items-center gap-1.5">
    <Button
      variant="ghost"
      size="icon"
      aria-label="Back"
      onClick={onBack}
      className="-ml-1 text-muted-foreground"
    >
      <ArrowLeftIcon />
    </Button>
    <h2 className="min-w-0 flex-1 truncate text-h6 text-strong">{title}</h2>
    {action}
  </div>
);

export default ViewHeader;
